import { LogistikComponentProductOverview } from '@chancenlogistik/client/components/logistik-component-product-overview.js';
import type { LearningMaterial, LogistikProductSet } from '@chancenwerk/db/LogistikProduct.js';
import { customElement } from 'lit/decorators.js';

/**
 * @element hefte-component-product-overview
 */
@customElement('hefte-component-product-overview')
export class HefteComponentProductOverview extends LogistikComponentProductOverview<
  LearningMaterial | LogistikProductSet
> {}
